"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var account_export_1 = __importDefault(require("./account_export"));
var contact_apply_export_1 = __importDefault(require("./contact_apply_export"));
var contact_tanto_export_1 = __importDefault(require("./contact_tanto_export"));
var application_details_export_1 = __importDefault(require("./application_details_export"));
var SalesForceCsvOutputModuleFactory = /** @class */ (function () {
    function SalesForceCsvOutputModuleFactory() {
    }
    SalesForceCsvOutputModuleFactory.create = function (linkObject) {
        switch (linkObject) {
            case ReflectType_1.SalesForceReflectType.TORIHIKISAKI:
                return new account_export_1.default();
            case ReflectType_1.SalesForceReflectType.SEKININSYA_APPLY:
                return new contact_apply_export_1.default();
            case ReflectType_1.SalesForceReflectType.SEKININSYA_TANTO:
                return new contact_tanto_export_1.default();
            case ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS:
                return new application_details_export_1.default();
            default:
                throw "Unknown Link Object...." + linkObject;
        }
    };
    return SalesForceCsvOutputModuleFactory;
}());
exports.default = SalesForceCsvOutputModuleFactory;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/csv_output_module_factory.ts
// module id = n7vC
// module chunks = 1